
export class TaskAdditionalInfo  {
    constructor(
            public id?: number,
            public taskId?: number,
            public subTaskType?: string,
            public correctedFirstName?: string,
            public correctedLastName?: string,
            public correctedSsn?: string,
            public correctedDob?: any,
            public newIncomeAmount?: any,
            public employerName?: string,
            public employmentStartDate?: any,
            public salary?: any,
            public frequency?: string,
            public employmentStatus?: string,
            public employerContactPhone?: string,
            public isSecondJob?: any,
            public employmentEndDate?: any,
            public terminationReason?: string,
            public incomeChangeType?: string,
            public incomeType?: string,
            public createdBy?: string,
            public createdDt?: any,
            public lastModifiedBy?: string,
            public residentialAddressLine1?: string,
            public residentialAddressLine2?: string,
            public residentialCity?: string,
            public residentialState?: string,
            public residentialZip?: string,
            public residentialCounty?: string,
            public mailingAddressLine1?: string,
            public mailingAddressLine2?: string,
            public mailingCity?: string,
            public mailingState?: string,
            public mailingZip?: string,
            public phoneNumber?: string,
            public phoneType?: string,
            public email?: string,
            public otherType?: string,
            public issueReported?: string,  
            public complaintType?: string,  
            public notes?: string,  
            public copyResidentialAddress?: string,    
            public contactChangeType?: string,
            public discoveryDate?: string,
            public goodCauseMonth?: string,
            public goodCauseReason?: string,
            public nonComplianceMonth?: string,
            public nonComplianceReason?: string,
            public exemptionMonth?: string,
            public exemptionReason?: string,
        
            ) {
            }
        }
    


// WEBPACK FOOTER //
// ./src/app/shared/task-additional-info.model.ts